import { FieldErrorMessage, ValidatorField } from './types';

const validateField: ValidatorField = (value, validators, required) => {
  let checkResult: FieldErrorMessage | undefined = undefined;

  if (!value) {
    if (required) {
      return { status: 'error', message: 'Manca un campo obbligatorio' };
    }
    return undefined;
  }

  validators.forEach((validator) => {
    const errorMessage = validator(value);
    if (errorMessage) {
      checkResult = errorMessage;
    }
  });
  return checkResult;
};

export default validateField;
